import React, { useCallback } from 'react';
import { useFormContext } from 'react-hook-form';

import { ControlledCheckboxField } from 'shared/forms/ControlledCheckboxField';
import { CameFromType } from 'features/auth/ts';

import { useStyles } from './styles';
import i18n from 'locales/i18n';

type Props = {
  name: string;
  value: keyof typeof CameFromType;
  label: string;
  defaultChecked?: boolean;
};

export const CameFromOption: React.FC<Props> = ({ name, value, label }) => {
  const { watch } = useFormContext() ?? {};
  const checkIsOptionSelected = useCallback(() => watch(name), [name, watch]);

  const direction = i18n.dir();

  const classes = useStyles({ isOptionSelected: checkIsOptionSelected(), direction });

  return (
    <ControlledCheckboxField
      name={name}
      value={value}
      label={label}
      labelPlacement="start"
      classes={{ root: classes.cameFromOption }}
    />
  );
};
